import { render, staticRenderFns } from "./UpdateAvailableRedeems.vue?vue&type=template&id=594040d4&lang=pug&"
import script from "./UpdateAvailableRedeems.vue?vue&type=script&setup=true&lang=ts&"
export * from "./UpdateAvailableRedeems.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports